export default __webpack_public_path__ + "static/media/The Kruks Photography-558_tn.3ed61335.jpg";